import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const instance = axios.create({ baseURL: API });

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("kino_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default instance;

export const getTrackStreamUrl = (track) => {
  if (!track) return "";
  const token = localStorage.getItem("kino_token") || "";
  return `${API}/stream/track/${track.id}?auth=${encodeURIComponent(token)}`;
};

// Always the original file, never the transcoded HLS copy — the native player handles
// codecs itself (HEVC/DTS/TrueHD/Dolby Vision), so there's no reason to route it through
// the browser-safe transcode.
// Must be an absolute URL, not just API-relative: this is handed off to Kodi (an external
// process with no browser origin to resolve a relative path against), unlike every other
// URL in this file which only ever needs to work inside <video>/axios in the browser itself.
// lanBaseUrl (from GET /config/native-player-url) overrides window.location.origin when set —
// Kodi/the helper always run on the home LAN, so if the browser session is on the public
// domain (e.g. streamhoard.tomtomenterprises.com), using that origin here would hairpin the
// whole file transfer out through the WAN and back in, capped at uplink speed instead of LAN.
export const getDirectStreamUrl = (id, kind = "movie", lanBaseUrl = "") => {
  if (!id) return "";
  const token = localStorage.getItem("kino_token") || "";
  const path = kind === "episode" ? `/stream/episode/${id}` : `/stream/${id}`;
  const base = lanBaseUrl
    ? `${lanBaseUrl.replace(/\/$/, "")}/api`
    : (API.startsWith("http") ? API : `${window.location.origin}${API}`);
  return `${base}${path}?auth=${encodeURIComponent(token)}`;
};

// Hands the direct-stream URL off to the StreamHoard Player desktop helper (streamhoardplay://),
// which launches a native player to play it. No-op unless the user has installed that helper.
// player: "kodi" (default - full HEVC/DTS/TrueHD/Dolby Vision codec support) or "wmp"
// (Windows Media Player - simpler content only, no HEVC/Atmos/DoVi support, but already on
// every Windows machine with nothing extra to install).
export const getNativePlayerUrl = (id, kind = "movie", lanBaseUrl = "", player = "kodi") => {
  const streamUrl = getDirectStreamUrl(id, kind, lanBaseUrl);
  if (!streamUrl) return "";
  return `streamhoardplay://play?url=${encodeURIComponent(streamUrl)}&player=${encodeURIComponent(player)}`;
};
